import { ApolloError } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { ApolloErrorCode } from '@src/enums/apolloErrorCode.enum';
import { hasFields } from './object/helpers';

const globalIgnoredErrors: (number | string)[] = [401];

export function captureError(error: unknown, ignoreErrors: (number | string)[] = []): void {
  if (
    hasFields<{ code: number | string }>(error, ['code']) &&
    error.code &&
    globalIgnoredErrors.concat(ignoreErrors).includes(error.code)
  ) {
    return;
  }

  const stringifiedError = JSON.stringify(error);

  if (stringifiedError.length === 0) {
    Sentry.captureException(new Error(`Cannot capture empty error: ${stringifiedError}`));

    return;
  }

  // eslint-disable-next-line no-console
  console.error(error);

  Sentry.captureException(stringifiedError);
}

export function isErrorWithCode(error: unknown, code: ApolloErrorCode): boolean {
  if (!(error instanceof ApolloError)) {
    return false;
  }

  return error.graphQLErrors.some(error => {
    return error?.extensions?.code === code;
  });
}
